import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { DocumentForm } from '@/forms/DocumentForm'
import { Settings } from '@/interfaces/Settings'

export default function OrderNewPage() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'order',
  })
  const { data: settings, isLoading } = useSWR<Settings>(
    `/api/v2/settings`,
    apiFetcher,
  )
  const title = `${t('new.title')}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/orders',
        children: t('list.title'),
      },
      {
        href: '/order/new',
        children: title,
      },
    ],
  })

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <title>{title}</title>

      <DocumentForm
        type="order"
        settings={settings!}
      />
    </>
  )
}
